import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { useGsmBurnForm, UseGsmBurnFormResult } from '../../logic/useGsmBurnForm'
import { BurnForm } from './BurnForm'
import { SuccessPanel } from './SuccessPanel'

export function GsmBurnContainer({ simple }: { simple?: boolean }) {
  const burnData = useGsmBurnForm()

  if (simple) {
    return <Form burnData={burnData} />
  }

  return (
    <Panel className="gap-4 p-4 md:p-8 sm:p-8">
      <Panel.Header>
        <div className="flex flex-col items-start gap-4">
          <Typography variant="h3" gradient className="text-xl">
            Burn USDXL
          </Typography>
          <Typography variant="prompt" className="font-medium text-base">
            Redeem USDXL for USDT0
          </Typography>
        </div>
      </Panel.Header>
      <Panel.Content className="mx-auto w-full max-w-xl">
        <Form burnData={burnData} />
      </Panel.Content>
    </Panel>
  )
}

const Form = ({ burnData }: { burnData: UseGsmBurnFormResult }) => {
  return (
    <div>
      {burnData.pageStatus.state === 'success' && (
        <SuccessPanel
          fromAsset={burnData.fromAsset}
          toAsset={burnData.toAsset}
          resetForm={burnData.resetForm}
          fromLabel="Burned"
          toLabel="Received"
        />
      )}
      {burnData.pageStatus.state === 'form' && (
        <BurnForm
          actionsEnabled={burnData.pageStatus.actionsEnabled}
          gsmBurn={burnData.gsmBurn}
          gsmBurnState={burnData.gsmBurnState}
          assetsToBurnFields={burnData.assetsToBurnFields}
          form={burnData.form}
          guestMode={burnData.guestMode}
          openConnectModal={burnData.openConnectModal}
        />
      )}
    </div>
  )
}
